import React from 'react'
import { DataSuspense } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import map from 'lodash/map'
import Paging from './Paging'
import { useListViewContext } from './Context'
import { ProductGridLayout } from './ProductGridLayout'

export const Layout = () => {
  const { listResult } = useListViewContext()
  const { loading, list } = listResult

  return (
    <DataSuspense loading={loading}>
      <Stack gap={4}>
        {map(list, (product) => (
          <ProductGridLayout key={product?._id} {...product} />
        ))}
        <Paging />
      </Stack>
    </DataSuspense>
  )
}
